<template>
	<Container>
		<TopBar/>
		<div class="head">
			<div class="title">發展曆程</div>
		</div>
		<Scroller ref='scroller' class='scroller' :unitWidth='100' :wheelEnable='true'>
			<div  v-for='i in 15'>
				<div @click='showYear(2004 + i)' class="item" :class='{active:selectYear == 2004 + i}'>{{2004+i}}</div>
			</div>
		</Scroller>
		<div class="history">
			<div class="item" v-for='i in 8'>
				<div class="left">
					<p class="month" :class='{"last":i == 8,"first":i==1}'>09/09</p>
				</div>
				<div class="content">
					<img src="@/assets/t1.jpg">
					<div class="right">
						<p class="title">關於攜手關愛</p>
						<p class="detail">doTERRA多特瑞先進的實驗室使用高端的測試方法，來檢驗精油的純度及強度。當香氛混合物從植物原料蒸餾出來後，會分批進行嚴格檢驗。通過來源、萃取、檢測、應用等四道管卡，確保其達到CPTG標準，得以使顧客每次收到的精油品質都純正、安全、有效。保證精油純度及功效的檢驗包含了重金屬檢測、旋亮度檢測、比重檢測、摺射率檢測、感官測試、微生物檢測、氣相色譜/質譜分析、傅裏葉轉換紅外光譜儀、對掌性檢測、同位素分析等多種類的嚴格檢測。視覺、嗅覺、味覺和觸覺進行的測試。對蒸餾專家來說，感官是質量檢測的第一道防線， 實時性地告知産品接受度的高低。出現怪味、不均勻、或奇怪的顔色的瞬間。</p>
					</div>
				</div>
			</div>
		</div>
	</Container>
</template>

<script>
	import TopBar from '@/components/common/TopBar'
	import Scroller from '@/components/common/Scroller'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				selectYear:2019,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			TopBar,
			Scroller,
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getArticleDetailAction',
			]),
			async initData(){
				this.$refs.scroller.scrollToEnd()
			},
			showYear(year){
				this.selectYear = year
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.html {
		margin:0 10.42vw;
	}
	.head {
		position: relative;
		text-align: center;
		padding:20px 0;
		border-bottom: 1px solid #F3F4F5;
		.title {
			background-color:$theme-color;
			color:white; 
			padding: 3px 30px;
			border-radius: 40px;
			@include fontSize($font-size-24);
			font-weight: bold;
			display: inline-block;
			text-align: center;
		}
	}
	.scroller {
		width:760px;
		margin: 40px auto;
		.item {
			width: 100px;
			height: 40px;
			text-align: center;
			line-height: 40px;
			@include fontSize($font-size-20);
			cursor: pointer;
		}
		.active {
			color:$theme-color;
		}
	}
	.history {
		margin-bottom: 60px;
		.item {
			display: flex;
			max-width: 1560px;
			margin: 0 10vw;
			.left {
				.month {
					color:$theme-color;
					@include fontSize($font-size-20);
					height:100%;
					display: flex;
					flex-direction: column;
					&:after,&:before{
						content: '';
						width:1px;
						display: block;
						flex:1;
						margin:2px auto;
						border-left:thick dotted #666;
					}
					&:after {
						// margin-top: 10px;
					}
					&:before {
						// margin-bottom: 10px;
					}
				}
				.first:before,.last:after {
					border: none;
				}
			}
			
			.content {
				display: flex;
				padding: 10px 20px;
				box-shadow: 0 0 5px 1px rgba(0,0,0,.1);
				margin-left: 20px;
				margin-bottom: 20px;
				img {
					width:240px;
					display: block;
					object-fit: contain;
				}
				.right {
					margin-left: 20px;
					.title {
						color:$theme-color;
						@include fontSize($font-size-18);
						margin-bottom: 5px;
					}
				}
				
			}
		}
	}
</style>